<script setup>

</script>

<template>
  <div class="dashboard-container">
    <div class="dashboard-section">
      <div class="dashboard-section-header">
        <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Important</div>
        <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
      </div>
      <div class="dashboard-section-content">
        <div class="dashboard-section-content-italic">
          Vous avez déjà un dossier de recevabilité VAE en cours.<br/>
          Nous allons supprimer votre compte sur cet espace.<br/>
          Merci de prendre contact avec votre conseiller via le formulaire suivant : <a href="https://apform.fr/espace-salarie/contact-salarie/" target="_blank">https://apform.fr/espace-salarie/contact-salarie/</a><br/>
          <br/>
          Pour accéder à votre espace VAE : <a href="https://eva.apform.fr" target="_blank">https://eva.apform.fr</a><br/>
          <br/>
          L'équipe Apform.
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
